const styles = theme => ({
  btnSave: {
    marginRight: theme.spacing(1),
  },
  radioCardGroupTitle: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1) / 2,
  },
  radioCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%',
  },
  addProfile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  profileTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  profileIcon: {
    fontSize: '3rem',
  },
  profileName: {
    marginTop: theme.spacing(1) / 2,
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: 'center',
    wordBreak: 'break-all',
  },
  addProfileLink: {
    cursor: 'pointer',
  },
  addProfileName: {
    marginTop: theme.spacing(1) / 2,
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: 'center',
  },
  profilePermissions: {
    marginTop: theme.spacing(1),
    textTransform: 'uppercase',
    fontWeight: theme.typography.fontWeightMedium,
  },
})

export default styles
